import { render, staticRenderFns } from "./CreateOrganisationModal.vue?vue&type=template&id=16dcb217&scoped=true"
import script from "./CreateOrganisationModal.vue?vue&type=script&lang=js"
export * from "./CreateOrganisationModal.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganisationModal.vue?vue&type=style&index=0&id=16dcb217&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dcb217",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16dcb217')) {
      api.createRecord('16dcb217', component.options)
    } else {
      api.reload('16dcb217', component.options)
    }
    module.hot.accept("./CreateOrganisationModal.vue?vue&type=template&id=16dcb217&scoped=true", function () {
      api.rerender('16dcb217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/CreateOrganisationModal.vue"
export default component.exports